import { Communication } from "../communication"

export const WorkForceCommunication = ({pageSwap,goToScreen}) => {
    return(
      <Communication CustomerStage={5} pageSwap={pageSwap} goToScreen={goToScreen}/>
    )
}